export default "__VITE_PUBLIC_ASSET__7f1b64a6__"